import { inject, InjectionToken } from '@angular/core';

import { createSelector, StoreConfig } from '@ngrx/store';

import { IntegrationKinds, INTEGRATIONS_FEATURE_FLAGS } from '@recruitee/integrations-types';
import { createSingleEntityStore, memoizeSelector, SingleEntityState } from '@recruitee/ngrx';

export type IntegrationsFeatureFlag =
  | 'brockmeyer'
  | IntegrationKinds.GOOGLE_HANGOUTS_MEET
  | IntegrationKinds.ZOOM
  | IntegrationKinds.TEAMS
  | IntegrationKinds.JITSI
  | IntegrationKinds.XING
  | string;
export type IntegrationsFeatureFlags = Record<IntegrationsFeatureFlag, boolean>;

const { actions, reducer, namespace, selectors } = createSingleEntityStore<
  Record<IntegrationsFeatureFlag, boolean>
>()('integrations-feature-flags');

const IntegrationsFeatureFlagsActions: Pick<
  typeof actions,
  'fetch' | 'fetchSuccess' | 'fetchFailed'
> = actions;

const IntegrationsFeatureFlagsSelectors = {
  ...selectors,
  isEnabled: memoizeSelector((flag: IntegrationsFeatureFlag) =>
    createSelector(selectors.data, data => (data ? !!data[flag] : null)),
  ),
};

export const IntegrationsFeatureFlagsConfigToken = new InjectionToken(
  'IntegrationFeatureFlagsConfigToken',
  {
    providedIn: 'root',
    factory: (): StoreConfig<SingleEntityState<Record<string, boolean>>> => ({
      initialState: {
        loaded: true,
        failed: false,
        pending: false,
        error: false,
        data: inject(INTEGRATIONS_FEATURE_FLAGS),
      },
    }),
  },
);

export {
  IntegrationsFeatureFlagsActions,
  IntegrationsFeatureFlagsSelectors,
  reducer as IntegrationsFeatureFlagsReducer,
  namespace as IntegrationsFeatureFlagsNamespace,
};
